import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../../style.css';

function Empresas() {
  const details = [
    { icon: '📖', label: 'Libro', value: 'Opcional' },
    { icon: '🕮', label: 'Editorial', value: 'N/A' },
    { icon: '⌛', label: 'Horas por semana', value: '6 hrs (Recomendado)' },
    { icon: '📆', label: 'Duración del nivel', value: 'A convenir' },
  ];

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Inglés para Empresas | Culturlingua</title>
        <meta name="description" content="Programas corporativos a la medida de tu empresa" />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Inglés · Culturlingua</div>
        <h1>Inglés para Empresas</h1>
        <p>Programas corporativos a la medida de tu empresa</p>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'900px', margin:'0 auto'}}>

          <div style={{background:'white', borderRadius:'20px', padding:'40px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)', marginBottom:'32px'}}>
            <div className="section-tag">Acerca del curso</div>
            <h2 className="section-headline" style={{fontSize:'1.6rem', marginBottom:'16px'}}>Inglés para Empresas</h2>
            <p style={{color:'var(--muted)', lineHeight:'1.8'}}>¿Necesitas que tus empleados hablen inglés? Diseñamos un plan de trabajo personalizado a tus necesidades y al giro de tu empresa, buscando resultados inmediatos y tangibles. Aprenderán lo necesario para emplearlo directamente en su trabajo.</p>
          </div>

          <div style={{display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:'16px', marginBottom:'40px'}}>
            {details.filter(d => d.value !== 'N/A').map((d) => (
              <div key={d.label} style={{background:'white', borderRadius:'14px', padding:'24px', boxShadow:'0 2px 8px rgba(0,0,0,0.05)', display:'flex', alignItems:'flex-start', gap:'14px'}}>
                <div style={{fontSize:'1.6rem'}}>{d.icon}</div>
                <div>
                  <div style={{fontSize:'0.75rem', color:'var(--muted)', textTransform:'uppercase', letterSpacing:'0.5px', fontWeight:'600', marginBottom:'4px'}}>{d.label}</div>
                  <div style={{fontWeight:'600', color:'var(--navy)'}}>{d.value}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{background:'var(--navy)', borderRadius:'20px', padding:'40px', textAlign:'center'}}>
            <h3 style={{fontFamily:'Fraunces, serif', fontSize:'1.6rem', color:'white', fontWeight:'900', marginBottom:'12px'}}>
              ¿Listo para empezar?
            </h3>
            <p style={{color:'rgba(255,255,255,0.6)', marginBottom:'28px'}}>Sin compromisos. Te contactamos para orientarte.</p>
            <div style={{display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap'}}>
              <Link to="/contacto" className="btn-glow">Inscribirme →</Link>
              <Link to="/Examen-de-ubicacion" className="btn-outline">Examen de Ubicación</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Empresas;
